import styled, { css } from 'styled-components'

import Icon from '../../../components/Icon'
import { FormColorVariants, FormColorVariantValues } from '../../../types/form'

export const Container = styled.div<{ $isDisabled: boolean }>`
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 6px;

  ${(props) =>
    props.$isDisabled &&
    css`
      opacity: 0.4;
    `}
`

export const Label = styled.label<{ $isDisabled: boolean }>`
  display: flex;
  gap: 1.6rem;
  cursor: pointer;
  position: relative;
  align-items: center;

  & input:checked ~ svg {
    & use {
      color: white;
    }
  }

  & input:checked ~ svg use {
    visibility: visible;
  }

  ${(props) =>
    props.$isDisabled &&
    css`
      cursor: not-allowed;
    `}
`

export const LabelText = styled.p<{ $required: boolean; $isError?: boolean }>`
  ${({ theme }) => theme.textStyles.montserratSm};
  color: ${({ theme }) => theme.colors.blueSecondaryBis};

  ${(props) =>
    props.$required &&
    css`
      &:after {
        content: ' *';
      }
    `}

  ${(props) =>
    props.$isError &&
    css`
      color: ${props.theme.colors.error};
    `}
  
  & a {
    cursor: pointer;
    ${({ theme }) => theme.textStyles.montserratTextBaseMedium}
    color: ${({ theme }) => theme.colors.greyFields};
    text-decoration: underline;
    display: inline-flex;
  }
`

export const Box = styled.span`
  align-self: flex-start;
  display: inline-block;
  position: relative;
`

export const Checkbox = styled.input<{
  $isError?: boolean
  $variant?: FormColorVariantValues
}>`
  appearance: none;
  width: 2.5rem;
  height: 2.5rem;
  border: 1px solid ${({ theme }) => theme.colors.greyContour};
  border-radius: 0.5rem;
  background-color: ${({ theme }) => theme.colors.pureWhite};
  cursor: pointer;
  transition: all 0.3s ease;

  &:checked {
    background-color: ${({ theme, $variant }) =>
      $variant === FormColorVariants.Primary
        ? theme.colors.bluePrimary
        : theme.colors.greenAccent};

    border-color: ${({ theme, $variant }) =>
      $variant === FormColorVariants.Primary
        ? theme.colors.greyContour
        : theme.colors.greenAccent};
  }

  &:checked ~ svg {
    opacity: 1;
  }

  ${(props) =>
    props.disabled &&
    css`
      cursor: not-allowed;
    `}
  ${(props) =>
    props.$isError &&
    css`
      border-color: ${props.theme.colors.error};
    `}
`

export const StyledIcon = styled(Icon)`
  z-index: 1;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 12px;
  transition: all 0.3s ease;
  opacity: 0;
`

export const Error = styled.p`
  ${({ theme }) => theme.textStyles.firaSansTextBase}
  color: ${({ theme }) => theme.colors.error};
  margin-top: 0.5rem;
`

export const Help = styled.p`
  ${({ theme }) => theme.textStyles.montserratSm}
  font-size: 1.2rem;
  color: grey;
  margin-top: 0.5rem;
`
